// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderMobile_header__VA09v","logoLink":"HeaderMobile_logoLink__qkJGw","spacedGroup":"HeaderMobile_spacedGroup__GrgmM"};